import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams, useSearchParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { clearOrganizationSelectedMobileDevice, setOrganizationSelectedMobileDevice } from 'features/organizationSlice';
import { fetchAdminMobileDevices } from 'api/portal';
import { showErrorToast } from 'features/toastSlice';
import { isTrustedDevice, validateDeviceStatus } from 'utils/mobile-devices';
import AdminMobileDeviceStatusUpdate from 'components/AdminMobileDeviceStatusUpdate';
import AdminMobileDeviceRegistration from 'components/AdminMobileDeviceRegistration';

function AdminMobileDeviceStatus() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const params = useParams();
  const [searchParams] = useSearchParams();

  const { t } = useTranslation();

  const { deviceId } = params;
  const status = searchParams.get('status');

  const mobileDevice = useSelector((state) => state.organization.selectedMobileDevice);

  const onErrorFetchingDevice = () => {
    navigate('/braincare/admin-mobile-devices');
    dispatch(showErrorToast('organization.organization-mobile-devices-edit.error-fetch-device'));
  };

  useEffect(() => {
    if (!validateDeviceStatus(status)) {
      dispatch(showErrorToast('messages.load-failure'));
      navigate('/braincare/admin-mobile-devices');
      return;
    }

    if (mobileDevice.org_device_id !== deviceId) {
      dispatch(clearOrganizationSelectedMobileDevice());
    }

    fetchAdminMobileDevices(new URLSearchParams(), { org_device_id: deviceId })
      .then((response) => {
        const { data } = response;

        if (!data.results) {
          onErrorFetchingDevice();
        } else if (data.results.length === 1) {
          const device = data.results[0];
          dispatch(clearOrganizationSelectedMobileDevice());
          dispatch(setOrganizationSelectedMobileDevice(device));
        } else {
          onErrorFetchingDevice();
        }
      })
      .catch(() => onErrorFetchingDevice());
  }, []);

  if (isTrustedDevice(status)) {
    return (
      <AdminMobileDeviceRegistration
        title={t('organization.organization-mobile-devices-edit.title-edit-device', { name: mobileDevice.name })}
        currentNav={t('organization.breadcrumbs.edit-organization-mobile-device')}
        device={mobileDevice}
      />
    );
  }

  return <AdminMobileDeviceStatusUpdate device={mobileDevice} />;
}

export default AdminMobileDeviceStatus;
